import { gql } from 'graphql-request'

export namespace PlannerQueries {
  export const QUERY_KEY = 'getDailyPlanner'

  export function getDailyPlanner() {
    return gql`
      query getDailyPlanner($filter: DailyPlannerFilter) {
        dailyPlanner(filter: $filter) {
          recordId
          completedAt
          createdAt
          dueDate
          endTime
          homeId
          jobId
          name
          recordType
          reservationId
          scheduleType
          startTime
          status
          type
          updatedAt
          reservation {
            id
            member {
              fullName
            }
          }
          home {
            searchDocument
            property {
              id
              directPartnerUser {
                fullName
                email
                phone
              }
            }
          }
          job {
            jobTemplate {
              name
            }
          }
        }
      }
    `
  }
}
